import dayjs from 'dayjs';
import API from '~/enums/API';
import generateUniqueId from '~/utils/generateUniqueId';

const { VITE_APP_SAS_URL, VITE_APP_SECURE_AD_SERVER } = import.meta.env;

export default function redirectOnAnalytics({ groups, startDate, endDate }) {
  const realmName = sessionStorage.getItem('realm_name');
  const queryParams = {
    startDate:
      dayjs(startDate).format('YYYY-MM-DD 00:00:00') ||
      dayjs().subtract(1, 'day').format('YYYY-MM-DD 00:00:00'),
    endDate:
      dayjs(endDate).format('YYYY-MM-DD 23:59:59') ||
      dayjs().subtract(1, 'day').format('YYYY-MM-DD 23:59:59'),
    groups: groups,
  };

  // Identifier generated by this below function will never be same
  const uid = generateUniqueId();
  const urlParams = new URLSearchParams({ tid: uid });
  const expiryTime = dayjs().add(5, 'minute').valueOf();

  // Retrieve existing data or initialize an empty object
  const existingData = JSON.parse(localStorage.getItem('analytics_redirect_params')) || {};

  existingData[uid] = {
    values: queryParams,
    expiry: expiryTime,
  };

  localStorage.setItem('analytics_redirect_params', JSON.stringify(existingData));
  window.open(
    `${VITE_APP_SAS_URL}/${VITE_APP_SECURE_AD_SERVER}/${realmName}/${API.ANALYTICS_URL}?${urlParams}`,
    'secure-ad-server-app-1'
  );
}
